import ActivityDefinition from '@/models/activityDefinition';
import { OrchestrationRouteModel } from '@/models/orchestrationRouteModel';
import Workflow from '@/models/workflow';

export default class ConfigState {
  public activityDefinitions?: ActivityDefinition[];
  public orchestrationRouteModels?: OrchestrationRouteModel[];
  public workflows?: Workflow[];
}
